import React, { useEffect, useState } from 'react';
import Logo from './Logo';

export default function LoadingScreen() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      data-testid="loading-screen"
      className={`fixed inset-0 z-[100] bg-[#0A0A0B] flex flex-col items-center justify-center transition-opacity duration-700 ${
        done ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <Logo size={56} />
      <div className="mt-5 leading-tight text-center">
        <div className="font-display text-xl tracking-tight text-[#F5F5F2]">
          ALPHA <span className="text-[#C8102E]">7</span>
        </div>
        <div className="mt-1 font-mono text-[9px] tracking-[0.3em] uppercase text-[#A1A1AA]">
          Soluciones y Proyectos
        </div>
      </div>
      <div className="mt-8 w-48 h-[2px] bg-[#1F1F22] overflow-hidden relative">
        <div className="absolute inset-y-0 left-0 w-1/2 bg-[#C8102E] loader-bar" />
      </div>
      <div className="mt-6 font-mono text-[10px] tracking-[0.3em] text-[#A1A1AA] uppercase">
        Loading Corporate Identity
      </div>
    </div>
  );
}
